const reverseDate = (date) => {
    if (date) return date.toString().split("-").reverse().join("-");
    else 
      return "";
};

export default reverseDate;